import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_NEW_ENCOUNTER' as const;
export { ExportStatus as Status };
